import { IStockOrderDetail } from '../../../../../../../types/stockOrders';
import { formatRoundedUpNumber } from '../../../../../../../utils/formatNumbers';
import './StockOrderSummary.scss';

const StockOrderSummary = ({ billingData }: { billingData: IStockOrderDetail['billingData'] }) => {
  const total = `$${formatRoundedUpNumber(
    billingData?.orderResume?.reduce((acc, item) => acc + item.subtotal, 0),
    2
  )} ${billingData?.orderResume[0]?.currency ?? ''}`;

  return (
    <section className="stockOrderSummary">
      <h2 className="sectionTitle">Resumen de la orden</h2>
      <div className="stockOrderSummaryTable">
        <table className="summaryTable">
          <thead>
            <tr className="text-left">
              <th className="titleItem large summaryHeaderCell">Referencias</th>
              <th className="titleItem small summaryHeaderCell">Cantidad</th>
              <th className="titleItem medium summaryHeaderCell">Costo con IVA</th>
              <th className="titleItem medium summaryHeaderCell">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {billingData.orderResume.map((item, index) => {
              const subtotal = `$${formatRoundedUpNumber(item.subtotal, 2)} ${item.currency}`;
              const value = `$${formatRoundedUpNumber(item.value, 2)} ${item.currency}`;

              return (
                <tr key={index}>
                  <td className="py-2 text-sm summaryCell">{item.reference}</td>
                  <td className="py-2 text-sm summaryCell">{item.quantity}</td>
                  <td className="py-2 text-sm summaryCell">{value}</td>
                  <td className="py-2 text-sm summaryCell">{subtotal}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="border-t border-nudos-gray-200">
              <td colSpan={3} className="py-2 text-sm text-right summaryFooterCell">
                Total general
              </td>
              <td className="py-2 text-sm font-semibold summaryFooterCell">{total}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  );
};

export default StockOrderSummary;
